<template>
  <div class="page" style="overflow-y: hidden; margin-top: -6px; height: 100%">
    <div style="height: 100%; position: relative">
      <div
        class="box"
        style="
          padding-bottom: 10px;
          padding-top: 10px;
          position: absolute;
          width: 100%;
          top: 0;
          z-index: 3;
        "
        ref="tabNav"
      >
        <div class="boxNameLine" style="padding-bottom: 0px">
          <div>
            <div
              class="boxName"
              style="display: flex; flex-wrap: wrap; width: 1100px"
            >
              <div
                class="navItem"
                :class="[curNavDate == item.goodsItemsId ? 'active' : '']"
                @click="changeNav(item)"
                v-for="(item, index) in curPetJiyangList"
                :key="index"
              >
                {{ $public.FTime(item.fosterCareDate, "MM-DD") }}
              </div>
            </div>
          </div>
          <div class="boxNameR">
            <el-button type="warning" @click="$router.back()">返回</el-button>
          </div>
        </div>
      </div>
      <div
        style="
          height: 100%;
          box-sizing: border-box;
          overflow: auto;
          padding-bottom: 82px;
        "
        :style="{ 'padding-top': tabNavHeight + 'px' }"
      >
        <div>
          <!-- 基本信息 -->
          <div class="box">
            <div class="boxNameLine">
              <div class="boxName">基本信息</div>
              <div class="boxNameR"></div>
            </div>
            <!-- 基本信息 -->
            <div class="boxCon" style="padding: 0 20px 0">
              <el-form>
                <el-row>
                  <el-col :span="4">
                    <el-form-item label="顾客" :label-width="formLabelWidth">
                      <el-input
                        style="width: 130px"
                        size="mini"
                        disabled
                        :value="staticInfo.fosterCare.memberName"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="手机号" :label-width="formLabelWidth">
                      <el-input
                        style="width: 130px"
                        size="mini"
                        disabled
                        :value="staticInfo.fosterCare.memberMobile"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="宠物" :label-width="formLabelWidth">
                      <el-input
                        style="width: 130px"
                        size="mini"
                        disabled
                        :value="staticInfo.pet.petName"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="品种" :label-width="formLabelWidth">
                      <el-input
                        style="width: 130px"
                        size="mini"
                        disabled
                        :value="staticInfo.pet.typeName"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="年龄" :label-width="formLabelWidth">
                      <el-input
                        style="width: 100px"
                        size="mini"
                        disabled
                        :value="
                          staticInfo.pet.birthDay
                            ? $public.FAge(staticInfo.pet.birthDay)[0] +
                              '岁' +
                              $public.FAge(staticInfo.pet.birthDay)[1] +
                              '月'
                            : ''
                        "
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="体重" :label-width="formLabelWidth">
                      <el-input
                        style="width: 130px"
                        size="mini"
                        disabled
                        type="number"
                        v-model="staticInfo.pet.weight"
                      >
                        <template slot="append">千克</template>
                      </el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <el-form-item label="寄养时间">
                      {{ $public.FTime(staticInfo.pet.beginDate) }} ~
                      <el-date-picker
                        :disabled="
                          !($route.query.eid && staticInfo.pet.status !== 2)
                        "
                        v-model="datePickerValue"
                        @change="changeDatePickerValue"
                        type="datetime"
                        placeholder="选择日期时间"
                        size="mini"
                        :clearable="false"
                        style="width: 176px"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <!-- <el-col :span="4">
										<el-form-item label="体温" :label-width="formLabelWidth" required>
											<el-input style="width:130px;" size="mini" v-model="form.animalHeat" @input="changeTextNum" clearable>
												<template slot="append">摄氏度</template>
											</el-input>
										</el-form-item>
									</el-col>
									<el-col :span="4">
										<el-form-item label="呼吸" :label-width="formLabelWidth" required>
											<el-input style="width:130px;" size="mini" v-model="form.breatheRate" @input="changeTextNum" clearable>
												<template slot="append">次/分</template>
											</el-input>
										</el-form-item>
									</el-col>
									<el-col :span="4">
										<el-form-item label="体重" :label-width="formLabelWidth" required>
											<el-input style="width:130px;" size="mini" type="number" v-model="form.weight" @input="changeTextNum" clearable>
												<template slot="append">千克</template>
											</el-input>
										</el-form-item>
									</el-col>
									<el-col :span="4">
										<el-form-item label="心率" :label-width="formLabelWidth" required>
											<el-input style="width:130px;" size="mini" v-model="form.heartRate" @input="changeTextNum" clearable>
												<template slot="append">次/分</template>
											</el-input>
										</el-form-item>
									</el-col> -->
                </el-row>
              </el-form>
            </div>
          </div>
          <!-- 寄养 -->
          <div class="box">
            <div class="boxNameLine">
              <div class="boxName">寄养</div>
              <div class="boxNameR"></div>
            </div>
            <div class="boxCon">
              <el-form>
                <el-row>
                  <el-col :span="4"> </el-col>
                </el-row>
              </el-form>
              <el-table :data="[staticInfo]" style="width: 100%">
                <el-table-column label="单号" min-width="180">
                  <template slot-scope="props">
                    {{ props.row.careId }}
                  </template>
                </el-table-column>
                <el-table-column
                  label="寄养服务"
                  min-width="200"
                  prop="goodsName"
                >
                </el-table-column>
                <el-table-column label="规格" min-width="150">
                  <template slot-scope="props">
                    {{ props.row.skuValue }}
                  </template>
                </el-table-column>
                <el-table-column label="数量" min-width="70">
                  <template slot-scope="props">
                    {{ props.row.num }}
                  </template>
                </el-table-column>
                <el-table-column label="单位" min-width="80" prop="unit">
                </el-table-column>
                <el-table-column
                  label="标准价/会员价"
                  min-width="80"
                >
                <template slot-scope="props">
                    <span>{{props.row.originalPrice}}</span
                    >/
                    <span>{{props.row.vipPrice>0?props.row.vipPrice:props.row.originalPrice}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="活动"
                  prop="activityName"
                  min-width="150"
                >
                </el-table-column>
                <el-table-column label="优惠价" prop="price" min-width="80">
                </el-table-column>
                <el-table-column label="支付状态" min-width="170">
                  <template slot-scope="props">
                    <span v-if="props.row.isPay" style="color: #18a44c"
                      >已支付</span
                    >
                    <span v-else style="color: red">未支付</span>
                  </template>
                </el-table-column>
                <!-- <el-table-column label="操作" min-width="100">
									<template slot-scope="props">
										<el-button type="primary" v-if="props.row.isPay&&props.row.filePath" @click="seeInspectItem(props.row.filePath)" size="mini">取消</el-button>
									</template>
								</el-table-column> -->
              </el-table>
              <div class="totalLine">
                <div class="totalL">
                  <!-- <span style="margin-right: 40px;">已支付：{{tableMoney1.paid}}</span>
									<span style="color:red">未支付：{{tableMoney1.unpaid}}</span> -->
                </div>
                <div class="totalR">
                  <span
                    >总计：{{
                      $public.cheng(staticInfo.price, staticInfo.num)
                    }}</span
                  >
                </div>
              </div>
            </div>
          </div>
          <!-- 护理 -->
          <div class="box">
            <div class="boxNameLine">
              <div class="boxName">护理</div>
              <div class="boxNameR">
                <el-button
                  v-if="$route.query.eid && staticInfo.pet.status !== 2"
                  style="margin-left: 10px"
                  type="warning"
                  size="mini"
                  @click="drawer_addHuli_state = true"
                  >添加</el-button
                >
              </div>
            </div>
            <div class="boxCon">
              <el-form>
                <el-row>
                  <el-col :span="4"> </el-col>
                </el-row>
              </el-form>
              <el-table
                :data="staticInfo.nurseRecords"
                style="width: 100%"
                ref="table2"
              >
                <el-table-column label="编号" width="50">
                  <template slot-scope="props">
                    {{ parseInt(props.$index + 1) }}
                  </template>
                </el-table-column>
                <el-table-column
                  label="护理时间"
                  prop="goodsName"
                  min-width="120px"
                >
                  <template slot-scope="props">
                    {{ $public.FTime(props.row.nurseDate) }}
                  </template>
                </el-table-column>
                <el-table-column label="服务人" prop="serviceUserName">
                </el-table-column>
                <el-table-column label="项目" prop="nurseType">
                </el-table-column>
                <el-table-column label="描述" prop="nurseRemark">
                  <template slot-scope="props">
                    <el-popover
                      v-if="props.row.nurseRemark"
                      placement="top-start"
                      width="200"
                      trigger="hover"
                      :content="props.row.nurseRemark"
                    >
                      <i
                        class="el-icon-view"
                        style="color: #467eff; margin-left: 4px"
                        slot="reference"
                      ></i>
                    </el-popover>
                  </template>
                </el-table-column>
                <el-table-column label="体温(摄氏度)" prop="animalHeat">
                </el-table-column>
                <el-table-column label="呼吸(次/分)" prop="breatheRate">
                </el-table-column>
                <el-table-column label="体重(千克)" prop="weight">
                </el-table-column>
                <el-table-column label="心率(次/分)" prop="heartRate">
                </el-table-column>
                <el-table-column label="操作" width="120">
                  <template slot-scope="props">
                    <!-- <el-button type="text" @click="del(2,props.row)" size="mini">编辑</el-button> -->
                    <el-button
                      v-if="$route.query.eid && staticInfo.pet.status !== 2"
                      type="text"
                      @click="delHuli(props.row)"
                      size="mini"
                      >删除</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
              <!-- <div class="totalLine">
								<div class="totalL">
									<span style="margin-right: 40px;">已支付：{{tableMoney2.paid}}</span>
									<span style="color:red">未支付：{{tableMoney2.unpaid}}</span>
								</div>
								<div class="totalR">
									<span>总计：{{tableMoney2.total}}</span>
								</div>
							</div> -->
            </div>
          </div>
          <!-- 商品 -->
          <div class="box">
            <div class="boxNameLine">
              <div class="boxName">商品</div>
              <div class="boxNameR">
                <el-button
                  v-if="$route.query.eid && staticInfo.pet.status !== 2"
                  style="margin-left: 10px"
                  type="warning"
                  size="mini"
                  @click="drawer_salesGoods_state = true"
                  >添加</el-button
                >
              </div>
            </div>
            <div class="boxCon">
              <el-form>
                <el-row>
                  <el-col :span="4"> </el-col>
                </el-row>
              </el-form>
              <el-table
                :data="goodsOrderList"
                style="width: 100%"
                @selection-change="getPaidTotal(arguments[0], '3')"
                ref="table3"
              >
                <el-table-column
                  v-if="$route.query.eid"
                  type="selection"
                  :selectable="
                    (row) => {
                      return row.state === 1 || row.state === 2;
                    }
                  "
                  width="50"
                >
                </el-table-column>
                <el-table-column type="expand">
                  <template slot-scope="props">
                    <el-table
                      :data="props.row.order_item_list"
                      style="width: 100%; margin-bottom: 20px"
                      size="mini"
                      row-key="_id"
                      :empty-text="'无数据'"
                    >
                      <el-table-column label="商品名称" min-width="250">
                        <template slot-scope="goodsItem">
                          {{ goodsItem.row.goods_name }}
                        </template>
                      </el-table-column>
                      <el-table-column label="商品规格" min-width="250">
                        <template slot-scope="goodsItem">
                          {{ goodsItem.row.sku_value }}
                        </template>
                      </el-table-column>
                      <el-table-column label="标准价" min-width="80">
                        <template slot-scope="goodsItem">
                          {{ goodsItem.row.original_price }}
                        </template>
                      </el-table-column>
                      <el-table-column label="活动" min-width="150">
                        <template slot-scope="goodsItem">
                          {{
                            goodsItem.row.activity_info &&
                            goodsItem.row.activity_info.name
                          }}
                        </template>
                      </el-table-column>
                      <el-table-column label="优惠价" min-width="80">
                        <template slot-scope="goodsItem">
                          {{ goodsItem.row.price }}
                        </template>
                      </el-table-column>
                      <el-table-column label="商品数量" min-width="80">
                        <template slot-scope="goodsItem">
                          {{ goodsItem.row.num }}
                          <el-tooltip
                            v-if="
                              !$public.isNull(
                                goodsItem.row.order_item_goods_list
                              )
                            "
                            style="margin: 4px"
                            effect="dark"
                            placement="top"
                          >
                            <div slot="content">
                              <span
                                v-for="tm in goodsItem.row
                                  .order_item_goods_list"
                                :key="tm.custom_code + Math.random()"
                                >{{ tm.custom_code }}
                              </span>
                            </div>
                            <span style="cursor: pointer; color: #1890ff"
                              >条码</span
                            >
                          </el-tooltip>
                        </template>
                      </el-table-column>
                      <el-table-column label="小计" min-width="80">
                        <template slot-scope="goodsItem">
                          {{
                            $public.cheng(
                              goodsItem.row.price,
                              goodsItem.row.num
                            )
                          }}
                        </template>
                      </el-table-column>
                      <el-table-column label="销售人员" min-width="150">
                        <template slot-scope="goodsItem">
                          <span
                            v-for="staff in goodsItem.row.sales_list"
                            :key="staff._id"
                            style="margin-left: 2px"
                            >{{ staff.sales_name }}</span
                          >
                        </template>
                      </el-table-column>
                    </el-table>
                  </template>
                </el-table-column>
                <el-table-column label="单号" min-width="150">
                  <template slot-scope="props">
                    {{ props.row.no }}
                  </template>
                </el-table-column>
                <el-table-column label="类型" min-width="200" prop="order_type">
                </el-table-column>
                <el-table-column label="优惠券" prop="originalPrice">
                  <template slot-scope="props">
                    <span v-if="!$public.isNull(props.row.coupon_list)">{{
                      props.row.coupon_list[0].coupon_name
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="状态" min-width="70">
                  <template slot-scope="props">
                    {{ $public.formatOrderState(props.row.state) }}
                  </template>
                </el-table-column>
                <el-table-column label="小计" min-width="100">
                  <template slot-scope="props">
                    <div>{{ props.row.total_price }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="操作" min-width="100">
                  <template slot-scope="props">
                    <el-button
                      type="text"
                      v-if="
                        (props.row.state == 1 || props.row.state == 2) &&
                        props.row.state != -2
                      "
                      @click="cancelOrder(props.row)"
                      size="mini"
                      >取消订单</el-button
                    >
                    <el-button
                      type="text"
                      v-if="props.row.state == -2"
                      @click="deleteOrder(props.row)"
                      size="mini"
                      >删除订单</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
              <div class="totalLine">
                <div class="totalL">
                  <span style="margin-right: 40px"
                    >已支付：{{
                      $public.jian(goodsTotal.total, goodsTotal.unPaid)
                    }}</span
                  >
                  <span style="color: red"
                    >未支付：{{ goodsTotal.unPaid }}</span
                  >
                </div>
                <div class="totalR">
                  <span>总计：{{ goodsTotal.total }}</span>
                </div>
              </div>
            </div>
          </div>
          <!-- 洗美 -->
          <div class="box">
            <div class="boxNameLine">
              <div class="boxName">洗美</div>
              <div class="boxNameR">
                <el-button
                  v-if="$route.query.eid && staticInfo.pet.status !== 2"
                  style="margin-left: 10px"
                  type="warning"
                  size="mini"
                  @click="drawer_salesXimei_state = true"
                  >添加</el-button
                >
              </div>
            </div>
            <div class="boxCon">
              <el-form>
                <el-row>
                  <el-col :span="4">
                    <!-- <el-form-item label="添加" :label-width="formLabelWidth">
											<el-input style="width:200px;" disabled :value="'1'"></el-input>
										</el-form-item> -->
                    <!-- <el-button type="success" @click="openAddGoods(4)">添加</el-button> -->
                  </el-col>
                </el-row>
              </el-form>
              <el-table
                :data="ximeiOrderList"
                style="width: 100%"
                @selection-change="getPaidTotal(arguments[0], '4')"
                ref="table4"
              >
                <el-table-column
                  type="selection"
                  :selectable="
                    (row) => {
                      return row.state === 1 || row.state === 2;
                    }
                  "
                  width="50"
                >
                </el-table-column>
                <el-table-column type="expand">
                  <template slot-scope="props">
                    <el-table
                      :data="props.row.order_item_list"
                      style="width: 100%; margin-bottom: 20px"
                      size="mini"
                      row-key="_id"
                      :empty-text="'无数据'"
                    >
                      <el-table-column label="商品名称" min-width="250">
                        <template slot-scope="goodsItem">
                          {{ goodsItem.row.goods_name }}
                        </template>
                      </el-table-column>
                      <el-table-column label="商品规格" min-width="250">
                        <template slot-scope="goodsItem">
                          {{ goodsItem.row.sku_value }}
                        </template>
                      </el-table-column>
                      <el-table-column label="标准价" min-width="80">
                        <template slot-scope="goodsItem">
                          {{ goodsItem.row.original_price }}
                        </template>
                      </el-table-column>
                      <el-table-column label="活动" min-width="150">
                        <template slot-scope="goodsItem">
                          {{
                            goodsItem.row.activity_info &&
                            goodsItem.row.activity_info.name
                          }}
                        </template>
                      </el-table-column>
                      <el-table-column label="优惠价" min-width="80">
                        <template slot-scope="goodsItem">
                          {{ goodsItem.row.price }}
                        </template>
                      </el-table-column>
                      <el-table-column label="商品数量" min-width="80">
                        <template slot-scope="goodsItem">
                          {{ goodsItem.row.num }}
                          <el-tooltip
                            v-if="
                              !$public.isNull(
                                goodsItem.row.order_item_goods_list
                              )
                            "
                            style="margin: 4px"
                            effect="dark"
                            placement="top"
                          >
                            <div slot="content">
                              <span
                                v-for="tm in goodsItem.row
                                  .order_item_goods_list"
                                :key="tm.custom_code + Math.random()"
                                >{{ tm.custom_code }}
                              </span>
                            </div>
                            <span style="cursor: pointer; color: #1890ff"
                              >条码</span
                            >
                          </el-tooltip>
                        </template>
                      </el-table-column>
                      <el-table-column label="小计" min-width="80">
                        <template slot-scope="goodsItem">
                          {{
                            $public.cheng(
                              goodsItem.row.price,
                              goodsItem.row.num
                            )
                          }}
                        </template>
                      </el-table-column>
                      <el-table-column label="销售人员" min-width="150">
                        <template slot-scope="goodsItem">
                          <span
                            v-for="staff in goodsItem.row.sales_list"
                            :key="staff._id"
                            style="margin-left: 2px"
                            >{{ staff.sales_name }}</span
                          >
                        </template>
                      </el-table-column>
                    </el-table>
                  </template>
                </el-table-column>
                <el-table-column label="单号" min-width="150">
                  <template slot-scope="props">
                    {{ props.row.no }}
                  </template>
                </el-table-column>
                <el-table-column label="类型" min-width="200" prop="order_type">
                </el-table-column>
                <el-table-column label="优惠券" prop="originalPrice">
                  <template slot-scope="props">
                    <span v-if="!$public.isNull(props.row.coupon_list)">{{
                      props.row.coupon_list[0].coupon_name
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="状态" min-width="70">
                  <template slot-scope="props">
                    {{ $public.formatOrderState(props.row.state) }}
                  </template>
                </el-table-column>
                <el-table-column label="小计" min-width="100">
                  <template slot-scope="props">
                    <div>{{ props.row.total_price }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="操作" min-width="100">
                  <template slot-scope="props">
                    <el-button
                      type="text"
                      v-if="
                        (props.row.state == 1 || props.row.state == 2) &&
                        props.row.state != -2
                      "
                      @click="cancelOrder(props.row)"
                      size="mini"
                      >取消订单</el-button
                    >
                    <el-button
                      type="text"
                      v-if="props.row.state == -2"
                      @click="deleteOrder(props.row)"
                      size="mini"
                      >删除订单</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
              <div class="totalLine">
                <div class="totalL">
                  <span style="margin-right: 40px"
                    >已支付：{{
                      $public.jian(ximeiTotal.total, ximeiTotal.unPaid)
                    }}</span
                  >
                  <span style="color: red"
                    >未支付：{{ ximeiTotal.unPaid }}</span
                  >
                </div>
                <div class="totalR">
                  <span>总计：{{ ximeiTotal.total }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="box"
        style="
          position: absolute;
          display: flex;
          justify-content: space-between;
          z-index: 2;
          bottom: 0;
          text-align: right;
          width: 100%;
          box-sizing: border-box;
          margin-bottom: 0;
          background-color: #f5f7fa;
          opacity: 0.9;
          padding-left: 10px;
          padding-right: 20px;
        "
      >
        <div style="line-height: 40px">
          <span>已支付：</span
          ><span style="font-size: 25px; margin-right: 30px"
            >￥
            {{
              $public.jian(
                $public.jia(goodsTotal.total, ximeiTotal.total),
                $public.jia(goodsTotal.unPaid, ximeiTotal.unPaid)
              )
            }}
          </span>
          <span style="color: red">待支付：</span
          ><span style="font-size: 25px; color: red; margin-right: 30px"
            >￥{{ $public.jia(goodsTotal.unPaid, ximeiTotal.unPaid) }}</span
          >
        </div>
        <div>
          <span>总计：</span
          ><span style="font-size: 25px; margin-right: 30px"
            >￥{{ $public.jia(goodsTotal.total, ximeiTotal.total) }}</span
          >
          <span v-if="staticInfo.pet.status == 2">
            <el-button type="info">寄养已结束</el-button>
          </span>
          <span v-else>
            <el-button
              v-if="$route.query.eid"
              type="warning"
              @click="openStopJiyang"
              >结束寄养</el-button
            >
          </span>
          <el-button
            v-if="$public.jia(goodsTotal.unPaid, ximeiTotal.unPaid) > 0"
            type="warning"
            @click="openSettlement"
            style="margin-left: 20px"
            >结算</el-button
          >
        </div>
      </div>
    </div>
    <!-- 添加护理 -->
    <div v-if="drawer_addHuli_state">
      <drawerAddHuli
        :goodsItemsId="staticInfo.goodsItemsId"
        @submit="submit_drawerAddHuli"
      ></drawerAddHuli>
    </div>
    <!-- 创建商品订单 -->
    <div v-if="drawer_salesGoods_state">
      <drawerSalesGoods
        :goodsItemId="staticInfo.goodsItemsId"
        @submit="submit_drawerSalesGoods"
      ></drawerSalesGoods>
    </div>
    <!-- 创建洗美订单 -->
    <div v-if="drawer_salesXimei_state">
      <drawerSalesXimei
        :goodsItemId="staticInfo.goodsItemsId"
        @submit="submit_drawerSalesXimei"
      ></drawerSalesXimei>
    </div>
    <!-- 合单支付 -->
    <div v-if="dialog_settlement_state">
      <dialogMergeOrder
        :orderNoList="orderNoListSelected"
        @submit="submit_dialogSettlement"
      ></dialogMergeOrder>
    </div>
    <!-- 寄养结束 -->
    <div v-if="drawer_stop_state">
      <dialogStopJiyang
        :stopJiyangData="stopJiyangData"
        @submit="submit_drawerStop"
      ></dialogStopJiyang>
    </div>
  </div>
</template>
<script>
import drawerAddHuli from "./drawerAddHuli.vue";
import dialogStopJiyang from "./dialogStopJiyang.vue";
import drawerSalesGoods from "../../../components/drawerSalesGoods/drawer_salesGoods.vue";
import drawerSalesXimei from "../../../components/drawerSalesXimei/drawer_salesXimei.vue";
import dialogMergeOrder from "../../../components/dialog_mergeOrder.vue";
export default {
  components: {
    drawerSalesGoods,
    dialogStopJiyang,
    drawerSalesXimei,
    drawerAddHuli,
    dialogMergeOrder,
  },
  data() {
    return {
      curNavDate: "",
      formLabelWidth: "60px",
      curPetJiyangList: [],
      goodsOrderList: [],
      ximeiOrderList: [],
      goodsTotal: { unPaid: 0, total: 0 },
      ximeiTotal: { unPaid: 0, total: 0 },
      orderNoListSelected: [],

      datePickerValue: "",

      // 创建护理日志
      drawer_addHuli_state: false,
      // 创建商品订单
      drawer_salesGoods_state: false,
      // 创建洗美订单
      drawer_salesXimei_state: false,
      // 结束寄养
      drawer_stop_state: false,
      stopJiyangData: null,
      // 结算
      dialog_settlement_state: false,

      staticInfo: { fosterCare: {}, pet: {} },

      tabNavHeight: 0,
    };
  },
  computed: {
    curShopId() {
      return this.$store.state.shopId;
    },
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    // 结束寄养
    openStopJiyang() {
      let loading = this.$loading();
      this.$http
        .get("/api/FosterCare/Detail/Pet", {
          recordId: this.staticInfo.pet.recordId,
        })
        .then((res) => {
          loading.close();
          if (res.code == 0) {
            this.stopJiyangData = res.data;
            this.drawer_stop_state = true;
          }
        });
    },
    submit_drawerStop(obj) {
      if (obj.type === "success") {
        this.drawer_stop_state = false;
      } else {
        this.drawer_stop_state = false;
      }
      this.getDetail(this.staticInfo.goodsItemsId);
    },
    changeDatePickerValue() {
      let loading = this.$loading();
      this.$http
        .post("/api/FosterCare/UpdatePet", {
          recordId: this.staticInfo.recordId,
          endDate: new Date(this.datePickerValue)
            .getTime()
            .toString()
            .substr(0, 10),
        })
        .then((res) => {
          loading.close();
          if (res.code == 0) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.getDetail(this.staticInfo.goodsItemsId);
          }
        });
    },
    // 护理日志
    submit_drawerAddHuli(obj) {
      this.drawer_addHuli_state = false;
      if (obj.type === "success") {
        this.$message({
          message: "操作成功",
          type: "success",
        });
        this.getDetail(this.staticInfo.goodsItemsId);
      }
    },
    delHuli(row) {
      this.$confirm("确定删除该条护理日志?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let loading = this.$loading();
        this.$http
          .delete("/api/FosterCare/NurseRecord/Delete", {
            nurseRecordId: row.nurseRecordId,
          })
          .then((res) => {
            loading.close();
            if (res.code == 0) {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.getDetail(this.staticInfo.goodsItemsId);
            }
          });
      });
    },
    // 创建商品订单
    submit_drawerSalesGoods(obj) {
      this.drawer_salesGoods_state = false;
      this.getDetail(this.staticInfo.goodsItemsId);
      if (obj.type === "success") {
        this.$message({
          message: "商品订单创建成功",
          type: "success",
        });
      }
    },
    // 创建洗美订单
    submit_drawerSalesXimei(obj) {
      this.drawer_salesXimei_state = false;
      this.getDetail(this.staticInfo.goodsItemsId);
      if (obj.type === "success") {
        this.$message({
          message: "洗美订单创建成功",
          type: "success",
        });
      }
    },
    // 结算
    openSettlement() {
      let selected = this.$refs["table3"].selection.concat(
        this.$refs["table4"].selection
      );
      this.orderNoListSelected = [];
      for (let i = 0; i < selected.length; i++) {
        if (selected[i].state === 1 || selected[i].state === 2) {
          this.orderNoListSelected.push(selected[i].no);
        }
      }
      if (this.$public.isNull(this.orderNoListSelected)) {
        this.$message({
          message: "请先选择待结算的商品订单和洗美订单！！",
          type: "error",
        });
        return;
      }
      this.dialog_settlement_state = true;
    },
    submit_dialogSettlement(obj) {
      this.dialog_settlement_state = false;
      this.getDetail(this.staticInfo.goodsItemsId);
      if (obj.type === "success") {
        this.$message({
          message: "结算成功",
          type: "success",
        });
      }
    },
    changeNav(item) {
      this.getDetail(item.goodsItemsId);
    },
    // 获取数据
    getDetail(id) {
      let recordId = "";
      let goodsItemsId = "";
      if (this.$public.isNull(id)) {
        recordId = this.$route.query.eid || this.$route.query.sid;
      } else {
        goodsItemsId = id;
      }
      let params = {
        recordId: recordId,
        goodsItemsId: goodsItemsId,
      };
      this.$http.get("/api/FosterCare/Delay", params).then((res) => {
        if (res.code == 0) {
          this.staticInfo = res.data;
          this.datePickerValue = new Date(this.staticInfo.pet.endDate * 1000);
          console.log(this.datePickerValue);
          this.curNavDate = this.staticInfo.goodsItemsId;
          this.$store.commit(
            "jiyangguanli/set_goodsItemsId",
            this.staticInfo.goodsItemsId
          );
          this.$store.commit(
            "jiyangguanli/set_petWeight",
            this.staticInfo.pet.weight
          );
          this.getUserInfo(
            this.staticInfo.fosterCare.memberId,
            this.staticInfo.pet.petId
          );
          this.getCurPetJiyangList(recordId);
          this.getOrderList();
        }
      });
    },
    getUserInfo(userId, petId) {
      this.$util.getUserInfo(userId).then((data) => {
        this.$store.commit("jiyangguanli/set_userInfo", data);
        if (this.$public.isNull(data.pets_info)) {
          this.$message({
            message: "顾客宠物信息获取失败！！",
            type: "success",
          });
        } else {
          for (let i = 0; i < data.pets_info.length; i++) {
            if (data.pets_info[i]._id === petId) {
              this.$store.commit(
                "jiyangguanli/set_curPetInfo",
                data.pets_info[i]
              );
            }
          }
        }
      });
    },
    getCurPetJiyangList(recordId) {
      if (this.curPetJiyangList.length === 0) {
        let params = {
          recordId: recordId,
        };
        this.$http.get("/api/FosterCare/DaysList", params).then((res) => {
          if (res.code == 0) {
            this.curPetJiyangList = res.data;
            this.$nextTick(() => {
              this.tabNavHeight = this.$refs.tabNav.offsetHeight;
            });
          }
        });
      }
    },
    getOrderList() {
      let params = {
        other_param: [this.staticInfo.goodsItemsId], //宠物id   curNavDate
        // order_type_id:'1,2',
        state: "1,2,3",
        pageIndex: 1,
        pageSize: 50,
      };
      this.$http.post("/api/Order/OrderList", params).then((res) => {
        if (res.code === 0) {
          this.goodsOrderList = [];
          this.ximeiOrderList = [];
          let d = res.data.data;
          for (let i = 0; i < d.length; i++) {
            if (d[i].order_type_id === 1) {
              this.goodsOrderList.push(d[i]);
            } else if (d[i].order_type_id === 2) {
              this.ximeiOrderList.push(d[i]);
            }
          }
          this.$nextTick(() => {
            for (let i = 0; i < this.goodsOrderList.length; i++) {
              if (
                this.goodsOrderList[i].state === 1 ||
                this.goodsOrderList[i].state === 2 ||
                this.goodsOrderList[i].state === 3
              ) {
                this.$refs["table3"].toggleRowSelection(
                  this.goodsOrderList[i],
                  true
                );
              }
            }
            for (let i = 0; i < this.ximeiOrderList.length; i++) {
              if (
                this.ximeiOrderList[i].state === 1 ||
                this.ximeiOrderList[i].state === 2 ||
                this.ximeiOrderList[i].state === 3
              ) {
                this.$refs["table4"].toggleRowSelection(
                  this.ximeiOrderList[i],
                  true
                );
              }
            }
          });
        }
      });
    },
    cancelOrder(row) {
      this.$confirm("确定取消该订单?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$http
          .get("/api/Order/ReceivedOrder", {
            order_id: row._id,
          })
          .then((res) => {
            if (res.code == 0) {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.getDetail(this.staticInfo.goodsItemsId);
            }
          });
      });
    },
    deleteOrder(row) {
      this.$confirm("确定删除该订单?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$http
          .delete("/api/Order/DeleteOrder", {
            order_id: row._id,
          })
          .then((res) => {
            if (res.code == 0) {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.getDetail(this.staticInfo.goodsItemsId);
            }
          });
      });
    },
    getPaidTotal(arr, str) {
      if (str === "3") {
        this.goodsTotal = this.getTotal(arr);
      } else if (str === "4") {
        this.ximeiTotal = this.getTotal(arr);
      }
    },
    getTotal(arr) {
      let total = 0;
      let unPaid = 0;
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].state === 1 || arr[i].state === 2 || arr[i].state === 3) {
          total = this.$public.jia(total, arr[i].total_price);
        }
        if (arr[i].state === 1 || arr[i].state === 2) {
          unPaid = this.$public.jia(unPaid, arr[i].total_price);
        }
      }
      return { unPaid: unPaid, total: total };
    },
  },
};
</script>
<style scoped lang="scss">
.page {
  position: relative;
  .navItem {
    width: 80px;
    height: 40px;
    line-height: 40px;
    border-radius: 4px;
    background-color: #999999;
    margin: 2px 10px 2px 0;
    text-align: center;
    cursor: pointer;
    color: #fff;
    font-size: 20px;
    &.active {
      background: $mainColor;
    }
  }
  .box {
    padding: 20px 0;
    background-color: #fff;
    border-bottom: 1px solid #eeeeee;
    margin-bottom: 10px;
    .boxNameLine {
      display: flex;
      justify-content: space-between;
      padding: 0 20px 20px;
      .boxName {
        font-size: 14px;
        color: #333333;
      }
      .boxNameR {
      }
    }
    .boxCon {
      padding: 0px 0px 0;
      .totalLine {
        line-height: 65px;
        font-weight: bold;
        display: flex;
        justify-content: space-between;
        padding: 0 20px;
        .totalL {
          font-size: 14px;
        }
        .totalR {
          font-size: 14px;
        }
      }
      ::v-deep .el-form-item__content {
        .el-input-group {
          vertical-align: middle;
        }
      }
    }
  }
  .cishu {
    display: flex;
    ::v-deep .el-input__inner {
      padding: 0 5px;
    }
    ::v-deep .el-input-group__append {
      padding: 0 3px;
    }
  }
}
</style>
